/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Start und Enddatum mithilfe des Kalender-Widgets auswählen`
};

const en_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Select start and end date using the calendar widget`
};

const es_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Seleccione la fecha de inicio y fin utilizando el widget de calendario`
};

const fr_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Sélectionnez les dates de début et de fin à l'aide du widget calendrier.`
};

const it_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Selezionare la data di inizio e di fine utilizzando il widget del calendario`
};

const nl_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Selecteer een begin en einddatum met de kalenderwidget`
};

const pt_date_range_picker__trigger_aria_label = /** @type {(inputs: {}) => string} */ () => {
	return `Selecionar a data de início e de fim utilizando o widget de calendário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__trigger_aria_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__trigger_aria_label", locale)
	if (locale === "de") return de_date_range_picker__trigger_aria_label(inputs)
	if (locale === "en") return en_date_range_picker__trigger_aria_label(inputs)
	if (locale === "es") return es_date_range_picker__trigger_aria_label(inputs)
	if (locale === "fr") return fr_date_range_picker__trigger_aria_label(inputs)
	if (locale === "it") return it_date_range_picker__trigger_aria_label(inputs)
	if (locale === "nl") return nl_date_range_picker__trigger_aria_label(inputs)
	return pt_date_range_picker__trigger_aria_label(inputs)
};